import Parametro from 'core/models/SEG/parametro';
import Pagination from 'core/models/pagination';
import qs from 'qs';
import api from '../api';

const baseURL = `/SEG/Parametro`;

export const getParametroList = async (filters) => {
  const response = await api.get(`${baseURL}/Search`, {
    params: filters,
  });
  const { status, message, value } = response.data ?? {};

  return {
    status,
    message,
    data: value?.map((json) => new Parametro(json)) ?? [],
  };
};

export const getParametro = async (noParametro, nrSeqGrupoEmpresa) => {
  const response = await api.get(`${baseURL}/`, {
    params: { noParametro, nrSeqGrupoEmpresa },
  });
  const { value } = response.data ?? {};
  return value ? new Parametro(value) : {};
};

export const getParametroPaged = async (filters) => {
  const response = await api.get(`${baseURL}/SearchPaged`, {
    params: filters,
  });
  const { status, message, value, pagination } = response.data ?? {};

  return {
    status,
    message,
    data: value?.map((json) => new Parametro(json)) ?? [],
    pagination: new Pagination(pagination),
  };
};

export const saveParametro = async (data) => {
  const response = await api.post(`${baseURL}/`, data);
  return response.data ?? {};
};

export const deleteParametro = async (id) => {
  const response = await api.delete(`${baseURL}/`, { params: { id } });
  return response.data ?? {};
};

export const deleteAllParametro = async (ids) => {
  const response = await api.delete(`${baseURL}/DeleteAll`, {
    params: { ids },
    paramsSerializer: (params) => qs.stringify(params),
  });
  return response.data ?? {};
};

export const getEncryptedContent = async (conteudo) => {
  const response = await api.get(`${baseURL}/EncryptContent`, {
    params: { conteudo },
  });
  const { status, message, value } = response.data ?? {};

  return {
    status,
    message,
    data: value ?? '',
  };
};
